import { render, staticRenderFns } from "./CustomTableFilters.vue?vue&type=template&id=bccdae84&scoped=true"
import script from "./CustomTableFilters.vue?vue&type=script&lang=js"
export * from "./CustomTableFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccdae84",
  null
  
)

export default component.exports